const VENDORS = {
    webkit: {
        onchange: "webkitfullscreenchange",
        status: "webkitIsFullScreen",
        exit: "webkitExitFullscreen",
    },
    moz: {
        onchange: "mozfullscreenchange",
        status: "mozFullScreen",
        exit: "mozCancelFullScreen",
    },
    ms: {
        onchange: "MSfullscreenchange",
        status: "msFullscreen",
        exit: "msExitFullscreen",
    },
    default: {
        onchange: "fullscreenchange",
        status: "fullscreen",
        exit: "exitFullscreen",
    },
};

function isInFullScreen() {
    const vendorPrefix = getVendorPrefix();
    if (!vendorPrefix) {
        return;
    }

    const property = VENDORS[vendorPrefix].status;
    return getDocumentProperty(property);
}

function getDocumentProperty(property) {
    return window.document[property];
}

function getVendorPrefix() {
    if (typeof window === "undefined") {
        return null;
    }
    if (document.fullscreenEnabled !== undefined) {
        return "default";
    }
    if (document.webkitFullscreenEnabled !== undefined) {
        return "webkit";
    }
    if (document.mozFullScreenEnabled !== undefined) {
        return "moz";
    }
    if (document.msFullscreenEnabled !== undefined) {
        return "ms";
    }
}

function getFullScreenChangeEvent() {
    const vendorPrefix = getVendorPrefix();
    return vendorPrefix ? VENDORS[vendorPrefix].onchange : "";
}

function exitFullscreen() {
    const vendorPrefix = getVendorPrefix();
    if (vendorPrefix) {
        const exitFullscreenMethodName = VENDORS[vendorPrefix].exit;
        document[exitFullscreenMethodName]();
    }
}

export { isInFullScreen, exitFullscreen, getFullScreenChangeEvent };
